import React, { FC, useContext, useMemo } from 'react';

//components
import AampeTooltip from '../../../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';
//constants
import { FORMULA_IMAGE_SPEC_DATA } from '../../../../../constants/formula';
import ICONS from '../../../../../constants/icons';

//context
import { EditorContext } from '../../../../../context/EditorContext';

//hooks
import usePushIntegrationsQuery from '../../../../../hooks/pushIntegrations/usePushIntegrationsQuery';

//models
import { ImageSpecsModel } from '../../../../../models/formula.model';
import { PushIntegrationModel } from '../../../../../models/pushProvider.model';

import FormulaImageSpecsHoverCard from '../../../../../views/formulaCreate/FormulaImageSpecsHoverCard';

const ImageAlternateToolTip: FC = () => {
    const {
        editorDetails: { formulaType },
    } = useContext(EditorContext);
    const { data: pushIntegrationData } = usePushIntegrationsQuery();

    const providerData = useMemo<PushIntegrationModel | undefined>(
        () =>
            pushIntegrationData?.find((item) =>
                item.channels?.includes(formulaType!),
            ),
        [formulaType, pushIntegrationData],
    );

    const specsData = useMemo<ImageSpecsModel | undefined>(() => {
        if (providerData?.push_provider_name) {
            return FORMULA_IMAGE_SPEC_DATA[providerData?.push_provider_name!];
        }
    }, [providerData]);

    return (
        specsData && (
            <AampeTooltip
                title={<FormulaImageSpecsHoverCard specs_data={specsData} />}
                placement="bottom"
                arrow
                arrowColor={aampeTheme.colors.white}
                customZIndex={11000}
                backgroundColor={aampeTheme.colors.white}
                color={aampeTheme.colors.black}
                maxWidth={400}
                padding={0}
            >
                <IconContainer style={{ lineHeight: '0px' }}>
                    <Info size={18} />
                </IconContainer>
            </AampeTooltip>
        )
    );
};

const IconContainer = styled.div({
    lineHeight: '0px',
});

const Info = styled(ICONS.info)(() => ({
    cursor: 'pointer',
    color: aampeTheme.colors.gray600,
}));
export default ImageAlternateToolTip;
